export default __webpack_public_path__ + "static/media/deleteIcon.7518bf92.svg";